import React from 'react';

import BaseSvg from '../../BaseSvg';
import { InjectedSvgProps } from '../../hocs';

export default class BonusPositiveSvg extends React.PureComponent<InjectedSvgProps> {
    render() {
        const { fillColor, className } = this.props;

        let classNames: Array<string> = ['ddbc-bonus-positive-svg'];

        if (className) {
            classNames.push(className);
        }

        return (
            <BaseSvg className={classNames.join(' ')} viewBox="0 0 41 47.21997">
                <g id="BonusPositiveSvg-957056db-7a32-4414-b0f9-15127106d33d" data-name="Layer 2">
                    <g id="BonusPositiveSvg-93b3a063-2bdf-45cb-b3ab-29b21c402efe" data-name="Advantage">
                        <path
                            fill={fillColor}
                            d="M40.89,11.71,20.39,0,0,11.9.11,35.51l20.5,11.71L41,35.32ZM31.06,26.45H24.1v7.98H17.67V26.45H10.69v-5.9h6.98V12.79H24.1v7.76h6.96Z"
                        />
                    </g>
                </g>
            </BaseSvg>
        );
    }
}
